const dangerousSymbolPattern = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '[': '&lbrack;',
  ']': '&rbrack;',
  '"': '&quot;',
  "'": '&#39;',
  '\\': '&bsol;',
  '®': '&reg;',
  '©': '&copy;'
} as const

const decodePattern = {
  ...Object.entries(dangerousSymbolPattern).reduce((acc, [k, v]) => ((acc[v] = k), acc), {} as Record<string, string>)
}

const decodeBracketsPattern = {
  '&lbrack;': '[',
  '&rbrack;': ']'
} as const

const dangerousSymbolEx = new RegExp(
  `[${Object.keys(dangerousSymbolPattern)
    .map(v => ('\\' === v ? '\\\\' : '[' === v ? '\\[' : ']' === v ? '\\]' : v))
    .join('')}]`,
  'gm'
)

const htmlEntityEx = /&([\da-z]+|#\d{1,6}|#x[\da-f]{1,6});/gim

const htmlEntityCheckEx = /^&([\da-z]+|#\d{1,6}|#x[\da-f]{1,6});/i

const replace =
  'replaceAll' in String.prototype
    ? (String.prototype.replaceAll as typeof String.prototype.replace)
    : // eslint-disable-next-line @typescript-eslint/unbound-method
      String.prototype.replace

export const encode = (source: string): string => {
  if (!source) {
    return source
  }
  if ('string' !== typeof source) {
    return source
  }
  return replace.call(source, dangerousSymbolEx, (match, offset: number, string: string) =>
    '&' === match && htmlEntityCheckEx.test(string.slice(offset))
      ? match
      : dangerousSymbolPattern[match as keyof typeof dangerousSymbolPattern]
  )
}

export const encodeAll = (source: string): string => {
  if (!source) {
    return source
  }
  if ('string' !== typeof source) {
    return source
  }
  return replace.call(
    source,
    dangerousSymbolEx,
    (match: string) => dangerousSymbolPattern[match as keyof typeof dangerousSymbolPattern] as string
  )
}

/**
 *
 * @param {string|unknown} source
 * @param {RegExp?} pattern
 * @returns {string|unknown}
 */
export const decode = (source: string, pattern = decodePattern) => {
  if (!source) {
    return source
  }
  if ('string' !== typeof source) {
    return source
  }
  return replace.call(source, htmlEntityEx, match => (pattern[match] ? pattern[match] : match))
}

export const decodeBrackets = (source: string) => decode(source, decodeBracketsPattern)

export const escapeHtmlEntities = (str: string): string =>
  str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;')
